import React, { isValidElement } from "react";
import PropTypes from "prop-types";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Checkbox from "@mui/material/Checkbox";
import SFTypography from "../typography";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

const StyledFormLabel = styled(FormLabel)(() => ({
  display: "flex",
}));

const CustomCheckbox = ({
  checked = false,
  disabled = false,
  required = false,
  error = true,
  label,
  labelPlacement = "end",
  onChange,
  indeterminate = false,
  indeterminateIcon,
  checkedIcon,
  icon,
  ...props
}) => {
  const checkbox = (
    <Checkbox
      onChange={onChange}
      {...(typeof props.defaultChecked === "undefined" && { checked })}
      indeterminate={indeterminate}
      disabled={disabled}
      indeterminateIcon={indeterminateIcon}
      checkedIcon={checkedIcon}
      icon={icon}
      {...props}
    />
  );
  //FormControlLabel in this version of mui does not support required property.
  //So we are using FormLabel in order to get required property.
  return label ? (
    <FormControlLabel
      disabled={disabled}
      label={
        <StyledFormLabel error={error} required={required}>
          {isValidElement(label) ? (
            label
          ) : (
            <SFTypography variant="formElementText">{label}</SFTypography>
          )}
        </StyledFormLabel>
      }
      labelPlacement={labelPlacement}
      control={checkbox}
    />
  ) : (
    <FormControlLabel disabled={disabled} control={checkbox} />
  );
};

CustomCheckbox.propTypes = {
  /* Label positioning if a label is supplied */
  labelPlacement: PropTypes.oneOf(["bottom", "end", "start", "top"]),
  /* The label to display */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /* If true, the component is checked. */
  checked: PropTypes.bool,
  /* If true, the component is disabled. */
  disabled: PropTypes.bool,
  /* Callback fired when the state is changed.*/
  onChange: PropTypes.func,
  /* If true it will render the indeterminate icon.Has more weight than checked*/
  indeterminate: PropTypes.bool,
  /* Icons state setup */
  indeterminateIcon: PropTypes.node,
  checkedIcon: PropTypes.node,
  icon: PropTypes.node,
};

export default CustomCheckbox;
